import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { TranslateModule, TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.scss'],
  imports: [CommonModule, TranslateModule, FormsModule],
  standalone: true,
})
export class PaginationComponent {
  @Input() type: string = '';
  @Input() currentPage: number = 1;
  @Input() totalPage: number = 1;
  @Input() pageSize: number = 10;
  @Input() pageSizes: number[] = [10, 25, 50, 100];
  @Input() totalItems: number = 0;
  @Input() items: any[] = [];

  @Output() pageChange = new EventEmitter<number>();
  @Output() pageSizeChange = new EventEmitter<number>();

  constructor(private translate: TranslateService) {
    const userLang = localStorage.getItem('selectedLanguage') || 'en';
    this.translate.use(userLang);
  }

  changePage(page: number): void {
    if (page > 0 && page <= this.totalPage) {
      this.pageChange.emit(page);
    }
  }

  changePageSize(event: Event): void {
    const selectElement = event.target as HTMLSelectElement;
    const size = Number(selectElement.value);
    this.pageSizeChange.emit(size);
  }

  getMiddlePages(): number[] {
    const pages: number[] = [];
    const start = Math.max(2, this.currentPage - 1);
    const end = Math.min(this.totalPage - 1, this.currentPage + 1);

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  }
}
